// @flow

import { getEntities } from 'modules/selector';

export const getGroupRankEntities = getEntities('groupRanks');
